module.exports = function() {
  return new Worker(__webpack_public_path__ + "97f8012fecbb7a094724.worker.js");
};